export default function(eventEmitter, listFilters){

    /**
     * Sets the browser history and URL params based on active pagination
     * @param page int > 0
     * @param sort string best|review|resp_time
     * @param activeTab string 'responses|matches' akin to the `ls` param
     */
    const pushUrlParamsToHistory = ({page, sort, activeTab, filterParams}) => {
        let defaults = getUrlParams();
        let lt = activeTab ?? $('#seller-list-tabbed-nav .tab-pane.active').prop('id')?.replace('-tab','') ?? defaults.lt;
        let p = page ?? defaults.p;
        let ls = sort ?? defaults.ls;
        let fp = filterParams ?? defaults.filterParams;
        QS.setValue('p', p, false);
        QS.setValue('ls', ls, false);
        QS.setValue('lt', lt, false);

        Object.keys(fp).forEach((param) => {
            QS.setValue(param, fp[param], false);
        });

        window.history.pushState({p, ls, lt, fp}, '', '?' + QS.toRaw());
    }

    const replaceUrlParamsInHistory = (overrideParams) => {
        const {p, ls, lt, fp} = {
            ...getUrlParams(),
            ...overrideParams
        };
        window.history.replaceState({p, ls, lt, fp}, '');
    }

    /**
     * Returns the current URL Params, or sensible defaults, for the Page, Sort, and active Tab identifier
     * For split suggestions/responses list
     *
     * @returns {{p: int, ls: 'best|review|resp_time', lt: 'matches|responses'}} P: pageNumber, ls: List Sort, ls: List Tab
     */
    const getUrlParams = () => {
        let p = parseInt(QS.getValue('p', 1));
        if (isNaN(p) || p < 1) {
            p = 1;
        }
        let lt = QS.getValue('lt', null);
        if ( lt !== 'matches' && lt !== 'responses') {
            lt = $('#seller-list-tabbed-nav .nav-link.active').prop('id') ?? 'matches';
        }
        let ls = QS.getValue('ls', 'best');
        if (ls !== 'review' && ls !== 'best' && ls !== 'resp_time' && ls !== 'distance')
        {
            ls = 'best';
        }

        let filterParams = getFilterParamsFromUrl();

        return {p, lt, ls, filterParams};
    }

    const appendUrlParamsToUrl = (urlString) => {
        let url = new URL(urlString);
        let {p, lt, ls, filterParams} = getUrlParams();
        url.searchParams.append('p', p);
        url.searchParams.append('lt', lt);
        url.searchParams.append('ls', ls);

        if(filterParams){
            Object.keys(filterParams).forEach((param) => {
                url.searchParams.append(param, filterParams[param]);
            });
        }

        return url;
    }

    const returnUrlQueryString = () => {
        let {p, lt, ls} = getUrlParams();
        return `p=${p}&lt=${lt}&ls=${ls}`;

    }

    const getFilterParamsFromUrl = () => {
        let filterKeys = listFilters.getFilterKeys();
        let params = {};
        filterKeys.forEach((key) => {
            let value = QS.getValue(key, null);
            if(value){
               params[key] = value;
            }
        });

        return params;
    };

    const removeFilterParamsFromUrl = () => {
        let filterKeys = listFilters.getFilterKeys();
        filterKeys.forEach((key) => {
            QS.deleteValue(key, false);
        });
    };


    const buildFilterQuery = (filterParamsObj) => {
        
        let queryParams = [];

        let showFiltersPrefix = 'show[filters]=1';

        if(filterParamsObj){
            Object.keys(filterParamsObj).forEach((param) => {
                if(filterParamsObj[param]){
                    queryParams.push(`filter[${param}][0]=${filterParamsObj[param]}`);
                }
            });
        }

        return queryParams.length > 0 ? `${showFiltersPrefix}&${queryParams.join('&')}` : showFiltersPrefix;
    };


    return {
        getUrlParams,
        pushUrlParamsToHistory,
        appendUrlParamsToUrl,
        returnUrlQueryString,
        buildFilterQuery,
        removeFilterParamsFromUrl,
        replaceUrlParamsInHistory
    }
}
